import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from '@mui/material';

/** The one time an invitation's link can be seen, in case the email doesn't arrive. */
export function InviteLinkDialog({ url, onClose }: { url: string; onClose: () => void }) {
  return (
    <Dialog open onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Invitation Sent</DialogTitle>
      <DialogContent>
        <Typography color="text.secondary" sx={{ mb: 2 }}>
          We emailed them a link. If it doesn't arrive, send them this one yourself. It works once,
          expires in 7 days, and won't be shown again.
        </Typography>
        <TextField
          fullWidth
          label="Invitation Link"
          value={url}
          slotProps={{ htmlInput: { readOnly: true } }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Done</Button>
      </DialogActions>
    </Dialog>
  );
}
